export default __webpack_public_path__ + "static/media/Sneaker_16_9.abe35c0b.png";